import { useMemo } from 'react';

import { useLearningUserCourseDetailQueryQuery } from './graphql/org-course-detail-collaborator-v2-query.v5.generated';
import { mapCollaboratorV2ToCourse } from './map-collaborator-v2-to-course';
import { mapCollaboratorV2ToDocument } from './map-collaborator-v2-to-document';

type TUseKnowledgeHubCourseV2Args = {
  organizationId: string;
  contentId: number;
  skip?: boolean;
};

export const useKnowledgeHubCourseV2 = ({
  organizationId,
  contentId,
  skip,
}: TUseKnowledgeHubCourseV2Args) => {
  const { data, loading, error, refetch } =
    useLearningUserCourseDetailQueryQuery({
      context: { clientName: 'v5' },
      variables: { organization_id: organizationId, content_id: contentId },
      skip,
      fetchPolicy: 'cache-first',
    });

  const contentBase =
    data?.knowledge_hub_collaborator_v2.get_collaborator_content_detail;

  const course = useMemo(() => {
    if (!contentBase) {
      return undefined;
    }

    return mapCollaboratorV2ToCourse(contentBase);
  }, [contentBase]);

  const document = useMemo(() => {
    if (!contentBase) {
      return undefined;
    }

    return mapCollaboratorV2ToDocument(contentBase);
  }, [contentBase]);

  return { course, document, loading, error, refetch };
};
